import script from "./logs-list.vue?vue&type=script&setup=true&lang=ts"
export * from "./logs-list.vue?vue&type=script&setup=true&lang=ts"

import "./logs-list.vue?vue&type=style&index=0&id=200d7b20&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-200d7b20"]])

export default __exports__